import { Modal, Input } from "antd";
import { useState } from "react";
import { useMobxStores } from "../stores/stores";
import "../components/RequestItem/RequestItemPreview.css";

const RequestListingApplicationModal = ({
  showApplicationModal,
  setShowApplicationModal,
  requestId,
}) => {
  const { requestsStore } = useMobxStores();
  const [email, setEmail] = useState("");
  const [isValid, setIsValid] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsValid(e.target.validity.valid);
  };

  const handleApply = async () => {
    const formData = new FormData();
    formData.append("listing", requestId);
    formData.append("email", email);

    setShowApplicationModal(false);
    setEmail("");
    await requestsStore.PostRequest(formData);
  };

  return (
    <Modal
      open={showApplicationModal}
      okButtonProps={{
        disabled: !isValid || email.trim() === "",
      }}
      onOk={() => handleApply()}
      onCancel={() => {
        setShowApplicationModal(false);
        setEmail("");
      }}
      className="apply-modal"
      title="Apply to listing"
    >
      <label>Email</label>
      <Input type="email" value={email} onChange={handleInputChange} />
    </Modal>
  );
};

export { RequestListingApplicationModal };
